import { graphql, useStaticQuery } from 'gatsby';
import { IProduct } from '../types';
import { parseData } from '../helpers';

export type IPreOwnedData = {
  posts: {
    edges: {
      node: IProduct;
    }[];
  };
};

const usePreOwnedData = (slug: string | null) => {
  const data: IPreOwnedData = useStaticQuery(graphql`
    {
      posts: allStoryblokEntry(
        filter: { field_component: { eq: "pre-owned-product" } }
      ) {
        edges {
          node {
            id
            uuid
            name
            slug
            full_slug
            content
            created_at
          }
        }
      }
    }
  `);

  // // If slug is null or an empty string, return all pre owned objects that start with "pre-owned"
  // if (slug === null || slug === '') {
  //   return data.posts.edges
  //     .map((edge: any) => edge.node)
  //     .filter((node: any) => node.full_slug.startsWith('pre-owned'));
  // }

  // // Determine the language prefix from the slug
  // const languagePrefix = slug?.split('/')[1] || ''; // Get the language part, or empty for root

  // // Filter pre owned objects by the current language context
  // const filteredPreOwned = data.posts.edges
  //   .map((edge: any) => edge.node)
  //   .filter((node: any) => {
  //     if (languagePrefix) {
  //       // If in the /en/ path, match pre owned objects that have "en/" in their full_slug
  //       return node.full_slug.startsWith(`${languagePrefix}/`);
  //     } else {
  //       // If in the default page, match pre owned objects that start with "pre-owned"
  //       return node.full_slug.startsWith('pre-owned');
  //     }
  //   });

  // return filteredPreOwned;

  if (slug === null || slug === '') {
    slug = '/';
  }

  const parsedData = parseData(
    data.posts.edges
      .map((edge: any) => edge.node)
      .filter((node: any) => node.full_slug.startsWith('stock-boats'))
  );

  const filteredByMarket = parsedData.filter((node: any) => {
    const marketLanguage = Array.isArray(node.content?.market_language)
      ? node.content.market_language
      : [];

    return marketLanguage.length === 0 || marketLanguage.includes(slug);
  });

  return filteredByMarket;
};

export default usePreOwnedData;
